module.exports = __webpack_public_path__ + "static/media/fig_24b.4b1fca88.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/fig_24b.jpg
// module id = 663
// module chunks = 0